// Иконки интерфейса (те же, что в прежнем приложении).

export const IconOrg = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x={9} y={3} width={6} height={5} rx={1.5} />
    <rect x={3} y={16} width={6} height={5} rx={1.5} />
    <rect x={15} y={16} width={6} height={5} rx={1.5} />
    <path d="M12 8v4M6 16v-2h12v2" />
  </svg>
);

export const IconMap = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <circle cx={6} cy={5} r={2.2} />
    <circle cx={18} cy={12} r={2.2} />
    <circle cx={8} cy={19} r={2.2} />
    <path d="M8 6.3 15.9 10.9M16.1 13.7 10 17.8" />
  </svg>
);

export const IconGroups = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3 3 8l9 5 9-5-9-5" />
    <path d="M3 12.5l9 5 9-5" />
    <path d="M3 17l9 5 9-5" />
  </svg>
);

export const IconGloss = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5V6a2 2 0 0 1 2-2h14v14H6.5A2.5 2.5 0 0 0 4 20.5V19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M9 8h7" />
  </svg>
);

export const IconExit = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="M16 17l5-5-5-5" />
    <path d="M21 12H9" />
  </svg>
);

export const IconKey = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <circle cx={8} cy={15} r={4} />
    <path d="M10.8 12.2 21 2M15 8l3 3" />
  </svg>
);

export const IconCollapse = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 7l-5 5 5 5M18 7l-5 5 5 5" />
  </svg>
);

export const IconBurger = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round">
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

export const IconBell = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 8-3 8h18s-3-1-3-8" />
    <path d="M13.7 20a2 2 0 0 1-3.4 0" />
  </svg>
);

export const IconBuilding = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 21V5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v16" />
    <path d="M15 9h4a1 1 0 0 1 1 1v11" />
    <path d="M2 21h20" />
    <path d="M8 8h3M8 12h3M8 16h3" />
  </svg>
);

export const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x={3.5} y={5} width={17} height={15.5} rx={2.5} />
    <path d="M8 3v4M16 3v4" />
    <path d="M3.5 10h17" />
  </svg>
);

export const IconGantt = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 6h7M8 12h9M12 18h8" />
    <path d="M4 3v18" opacity={0.4} />
  </svg>
);

export const IconGear = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <circle cx={12} cy={12} r={3.2} />
    <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.03 1.56V21a2 2 0 1 1-4 0v-.09a1.7 1.7 0 0 0-1.11-1.56 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87 1.7 1.7 0 0 0-1.56-1.03H3a2 2 0 1 1 0-4h.09a1.7 1.7 0 0 0 1.56-1.11 1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.7 1.7 0 0 0 1.87.34h.02a1.7 1.7 0 0 0 1.02-1.56V3a2 2 0 1 1 4 0v.09a1.7 1.7 0 0 0 1.03 1.56 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87v.02a1.7 1.7 0 0 0 1.56 1.02H21a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.51 1.03z" />
  </svg>
);

export const IconWalk = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
    <rect x={3} y={4} width={18} height={16} rx={1.5} />
    <path d="M8 4v16M16 4v16" opacity={0.35} />
    <circle cx={12} cy={12} r={2.4} />
    <circle cx={12} cy={12} r={0.4} />
  </svg>
);

export const IconArrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

// стрелка «назад» (глиф, толщина 2 — как у IconArrow)
export const IconArrowLeft = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 12H5M11 6l-6 6 6 6" />
  </svg>
);

// стереть символ (глиф, толщина 2)
export const IconBackspace = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.4 5.5h9.35a1.75 1.75 0 0 1 1.75 1.75v9.5a1.75 1.75 0 0 1-1.75 1.75H9.4a1.75 1.75 0 0 1-1.3-.58l-4.05-4.5a1.75 1.75 0 0 1 0-2.34l4.05-4.5a1.75 1.75 0 0 1 1.3-.58z" />
    <path d="M12.25 10.25l4 3.5M16.25 10.25l-4 3.5" />
  </svg>
);

export const IconChevronLeft = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="m15 6-6 6 6 6" />
  </svg>
);

// ручка перетаскивания (шесть точек)
export const IconGrip = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <circle cx={9} cy={6} r={1.6} /><circle cx={15} cy={6} r={1.6} />
    <circle cx={9} cy={12} r={1.6} /><circle cx={15} cy={12} r={1.6} />
    <circle cx={9} cy={18} r={1.6} /><circle cx={15} cy={18} r={1.6} />
  </svg>
);

// «ещё» (три точки)
export const IconMore = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <circle cx={5} cy={12} r={2} /><circle cx={12} cy={12} r={2} /><circle cx={19} cy={12} r={2} />
  </svg>
);

export const IconChat = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    {/* точка возврата хвоста лежит на самой окружности: при прежней (4,9; 18,4)
        хорда до (12,5; 4,5) была длиннее диаметра, браузер по правилам SVG сам
        увеличивал радиус левой дуги до 7,92 — пузырь выпирал влево до x=0,78 */}
    <path d="M20 12a7.5 7.5 0 0 1-7.5 7.5H8l-4 2.5 2.76-5.18A7.5 7.5 0 0 1 12.5 4.5 7.5 7.5 0 0 1 20 12z" />
    <path d="M9 10.5h7M9 14h4.5" opacity={0.55} />
  </svg>
);

/* ---------- иконки чата ----------
   Один стиль со всем приложением: контур толщиной 1.8, скруглённые концы,
   без заливок и эмодзи. */

export const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.75 12.5 9.5 17.25 19.25 6.75" />
  </svg>
);

export const IconCheckDouble = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M2.5 12.5 7 17l9.5-10" />
    <path d="M9 15.5l1.75 1.75L20.5 7" />
  </svg>
);

export const IconReply = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 7L4 12l5 5" />
    <path d="M4 12h9a6 6 0 0 1 6 6v1" />
  </svg>
);

export const IconPencil = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 20h4l10-10a2.4 2.4 0 0 0-3.4-3.4L4.6 16.6z" />
    <path d="M13.5 6.5l4 4" />
  </svg>
);

export const IconTrash = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.5 6.5h15" />
    <path d="M9.5 6.5V4.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75V6.5" />
    <path d="M6.5 6.5 7.4 19a1 1 0 0 0 1 .95h7.2a1 1 0 0 0 1-.95l.9-12.5" />
  </svg>
);

export const IconSmile = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <circle cx={12} cy={12} r={8.25} />
    <path d="M8.75 14.25a4 4 0 0 0 6.5 0" />
    <circle cx={9.25} cy={9.75} r={0.9} fill="currentColor" stroke="none" />
    <circle cx={14.75} cy={9.75} r={0.9} fill="currentColor" stroke="none" />
  </svg>
);

export const IconClip = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M19.5 11.75 12 19.25a4.75 4.75 0 0 1-6.72-6.72l7.72-7.72a3.25 3.25 0 0 1 4.6 4.6l-7.7 7.7a1.75 1.75 0 0 1-2.48-2.47l7.1-7.1" />
  </svg>
);

export const IconSend = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    {/* оптический сдвиг: габариты самолётика и так по центру клетки (замер
        getBBox — 11,97/11,93 при идеале 12/12), но масса фигуры уходит вверх
        влево, и в круглой кнопке он читался смещённым. Правка на вид, не на
        геометрию — принимать глазами. */}
    <g transform="translate(.6 .6)">
      <path d="M20.5 3.5 3.8 10.2a.6.6 0 0 0 .05 1.13l6.4 2.2 2.2 6.4a.6.6 0 0 0 1.13.05z" />
      <path d="M20.5 3.5 10.25 13.53" />
    </g>
  </svg>
);

export const IconHash = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 4L7.5 20M16.5 4L15 20M4.5 9h15M3.5 15h15" />
  </svg>
);

export const IconMegaphone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.5 10.25v3.5a1.75 1.75 0 0 0 1.75 1.75H8l8.5 4.25V4.25L8 8.5H6.25A1.75 1.75 0 0 0 4.5 10.25z" />
    <path d="M19.5 9.75a3.25 3.25 0 0 1 0 4.5" />
  </svg>
);

export const IconBuildingSmall = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 20.5V4.75A.75.75 0 0 1 5.75 4h7.5a.75.75 0 0 1 .75.75V20.5" />
    <path d="M14 10.5h4.25a.75.75 0 0 1 .75.75v9.25M3.5 20.5h17" />
    <path d="M8 8h3M8 12h3M8 16h3" />
  </svg>
);

export const IconSearch = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <circle cx={11} cy={11} r={6.5} />
    <path d="M16 16l4.5 4.5" />
  </svg>
);

export const IconChevronUp = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 14l6-6 6 6" />
  </svg>
);

export const IconChevronDown = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 10l6 6 6-6" />
  </svg>
);

export const IconClose = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const IconFile = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M13.75 3.5H7a1.5 1.5 0 0 0-1.5 1.5v14a1.5 1.5 0 0 0 1.5 1.5h10a1.5 1.5 0 0 0 1.5-1.5V8.25z" />
    <path d="M13.75 3.5v4.75h4.75" />
  </svg>
);

/* Лист со стрелкой вверх: подсказка броска файлов в переписку. Тот же лист,
   что у IconFile выше, только загнутый угол уступил место стрелке. */
export const IconFileUp = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M13.75 3.5H7a1.5 1.5 0 0 0-1.5 1.5v14a1.5 1.5 0 0 0 1.5 1.5h10a1.5 1.5 0 0 0 1.5-1.5V8.25z" />
    <path d="M13.75 3.5v4.75h4.75" />
    <path d="M12 18v-6" />
    <path d="m9.25 14.25 2.75-2.75 2.75 2.75" />
  </svg>
);

export const IconExternal = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M13.5 4.5h6v6" />
    <path d="M19.5 4.5 11 13" />
    <path d="M18.5 14.25v4.25a1.5 1.5 0 0 1-1.5 1.5H5.5a1.5 1.5 0 0 1-1.5-1.5V7a1.5 1.5 0 0 1 1.5-1.5h4.25" />
  </svg>
);

export const IconMention = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <circle cx={12} cy={12} r={3.5} />
    <path d="M15.5 12v1.75a2.25 2.25 0 0 0 4.5 0V12a8 8 0 1 0-3.2 6.4" />
  </svg>
);

export const IconDownload = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 4.25v10.5" />
    <path d="M8 11l4 4 4-4" />
    <path d="M4.75 17.25v1.5a1.5 1.5 0 0 0 1.5 1.5h11.5a1.5 1.5 0 0 0 1.5-1.5v-1.5" />
  </svg>
);

export const IconImage = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x={3.5} y={4.5} width={17} height={15} rx={2.5} />
    <circle cx={9} cy={9.75} r={1.5} />
    <path d="M4.25 16.5l4.5-4 3.25 2.75 3-2.5 4.75 4.25" />
  </svg>
);

export const IconPlay = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <path d="M8 5.5v13l11-6.5z" />
  </svg>
);

export const IconMic = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x={9.25} y={3.5} width={5.5} height={10} rx={2.75} />
    <path d="M5.75 11.25a6.25 6.25 0 0 0 12.5 0M12 17.5v3" />
  </svg>
);

/** Отдалить — пара к IconPlus, кнопки масштаба листа доски (11.09.2026). */
export const IconMinus = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14" />
  </svg>
);

export const IconPlus = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const IconChevronRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 6l6 6-6 6" />
  </svg>
);

/* ---------- звонки ---------- */

export const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.4 5.1 7.7 3.4a1.7 1.7 0 0 0-2.4 0L4 4.7a2.4 2.4 0 0 0-.5 2.7 20 20 0 0 0 11.1 11.1 2.4 2.4 0 0 0 2.7-.5l1.3-1.3a1.7 1.7 0 0 0 0-2.4l-1.7-1.7a1.7 1.7 0 0 0-2.4 0l-.7.7a13.6 13.6 0 0 1-4.4-4.4l.7-.7a1.7 1.7 0 0 0 0-2.4z" />
  </svg>
);

export const IconPhoneOff = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.4 5.1 7.7 3.4a1.7 1.7 0 0 0-2.4 0L4 4.7a2.4 2.4 0 0 0-.5 2.7 20 20 0 0 0 11.1 11.1 2.4 2.4 0 0 0 2.7-.5l1.3-1.3a1.7 1.7 0 0 0 0-2.4l-1.7-1.7a1.7 1.7 0 0 0-2.4 0l-.7.7a13.6 13.6 0 0 1-4.4-4.4l.7-.7a1.7 1.7 0 0 0 0-2.4z" />
    <path d="M3.5 3.5l17 17" />
  </svg>
);

export const IconMicOff = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.75 6.1V6.25a2.75 2.75 0 0 0-5.5 0v5.1m.8 2.05a2.75 2.75 0 0 0 4.7-1.15" />
    <path d="M5.75 11.25a6.25 6.25 0 0 0 9 5.35M18.25 11.25c0 .7-.12 1.4-.35 2.05M12 17.5v3" />
    <path d="M3.5 3.5l17 17" />
  </svg>
);

export const IconCamera = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x={2.75} y={6.25} width={12.5} height={11.5} rx={3} />
    <path d="M15.25 11l4.4-2.6a.9.9 0 0 1 1.35.78v5.64a.9.9 0 0 1-1.35.78L15.25 13z" />
  </svg>
);

export const IconCameraOff = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M15.25 11l4.4-2.6a.9.9 0 0 1 1.35.78v5.64a.9.9 0 0 1-1.35.78l-2.4-1.4" />
    <path d="M13.5 17.75H5.75a3 3 0 0 1-3-3v-5.5a3 3 0 0 1 3-3H9" />
    <path d="M3.5 3.5l17 17" />
  </svg>
);

export const IconHand = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 13.5V6.4a1.7 1.7 0 0 1 3.4 0v7.1" />
    <path d="M11.4 13.5V5.2a1.7 1.7 0 0 1 3.4 0v8.3" />
    <path d="M14.8 13.5V8a1.7 1.7 0 0 1 3.4 0v6.2A6.3 6.3 0 0 1 11.9 20.5a6.3 6.3 0 0 1-4.45-1.84l-3.1-3.1a1.6 1.6 0 0 1 2.26-2.26L8 15.2" />
  </svg>
);
/** Отсчёт времени в звонке — своя кнопка в плашке (решение Ильи 11.09.2026). */
export const IconTimer = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <circle cx={12} cy={13.5} r={7.75} />
    <path d="M12 9.75v3.75l2.5 1.6M9.5 2.75h5M18.6 7.1l1.4-1.4" />
  </svg>
);

/** Прошло с начала разговора — подпись у счётчика вверх (решение Ильи 11.09.2026). */
export const IconElapsed = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <circle cx={12} cy={12} r={8.25} />
    <path d="M12 7.5V12l3 1.9" />
  </svg>
);

/* Реакции звонка (решение Ильи 11.09.2026): рука висит, эти вспыхивают на три
   секунды. Тот же контур 1.8, что и у соседей. */
export const IconThumbUp = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 10.5v9.25H4.75A1.25 1.25 0 0 1 3.5 18.5v-6.75a1.25 1.25 0 0 1 1.25-1.25z" />
    <path d="M7 10.5 11.25 4a2 2 0 0 1 3.5 1.9L13.75 9.5h4.9a1.85 1.85 0 0 1 1.8 2.3l-1.5 6a2 2 0 0 1-1.95 1.5H7" />
  </svg>
);

export const IconThumbDown = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 13.5V4.25H4.75A1.25 1.25 0 0 0 3.5 5.5v6.75a1.25 1.25 0 0 0 1.25 1.25z" />
    <path d="M7 13.5 11.25 20a2 2 0 0 0 3.5-1.9l-1-3.6h4.9a1.85 1.85 0 0 0 1.8-2.3l-1.5-6A2 2 0 0 0 17 4.5H7" />
  </svg>
);

export const IconClap = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.5 12.5 7.2 10.2a1.5 1.5 0 0 1 2.1-2.1l2.3 2.3" />
    <path d="M11.6 10.4 9.1 7.9A1.5 1.5 0 0 1 11.2 5.8l3.4 3.4" />
    <path d="M14.6 9.2 13 7.6a1.5 1.5 0 0 1 2.1-2.1l3.6 3.6a5.5 5.5 0 0 1-7.8 7.8l-3.2-3.2" />
    <path d="M5.5 4.2 4.6 3M9 3.4 8.7 2M3.4 8.6 2 8.9" />
  </svg>
);

export const IconMinimize = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 14.25h5.75V20M20 9.75h-5.75V4" />
    <path d="M14.25 9.75 20.5 3.5M3.5 20.5 9.75 14.25" />
  </svg>
);
export const IconExpand = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.75 3.5h5.75v5.75M9.25 20.5H3.5v-5.75" />
    <path d="M20.5 3.5 14 10M3.5 20.5 10 14" />
  </svg>
);
export const IconScreen = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <path d="M8 20h8" /><path d="M12 16v4" />
  </svg>
);
export const IconPresenter = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <path d="M8 20h8" /><path d="M12 16v4" />
    <path d="M9 10h6" /><path d="M13 8l2 2-2 2" />
  </svg>
);
export const IconSignal = ({ level }: { level: 1 | 2 | 3 }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <rect x="3" y="14" width="4" height="7" rx="1" opacity={level >= 1 ? 1 : 0.25} />
    <rect x="10" y="9" width="4" height="12" rx="1" opacity={level >= 2 ? 1 : 0.25} />
    <rect x="17" y="3" width="4" height="18" rx="1" opacity={level >= 3 ? 1 : 0.25} />
  </svg>
);

/** Описание (строки текста) — действие «Добавить описание» в форме встречи (волна E). */
export const IconNotes = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 6.5h14M5 12h14M5 17.5h9" />
  </svg>
);

/** Счётчик просмотров у сообщения в группе. */
export const IconEye = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

/** Показ нескольких календарей — кнопка выбора на телефоне (CalendarPicker). */
export const IconLayers = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3.5l8.5 4.5-8.5 4.5L3.5 8 12 3.5z" />
    <path d="M3.5 12l8.5 4.5 8.5-4.5" />
    <path d="M3.5 16l8.5 4.5 8.5-4.5" />
  </svg>
);

/** Повтор встречи — блок «Повтор» в карточке события (задача 2026-09-10). */
export const IconRepeat = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12a8 8 0 0 1 13-6.2M20 5v4h-4" />
    <path d="M20 12a8 8 0 0 1-13 6.2M4 19v-4h4" />
  </svg>
);

/** Место встречи — блок «Где» в карточке события (задача 2026-09-10). */
export const IconPin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s7-7.58 7-12a7 7 0 0 0-14 0c0 4.42 7 12 7 12z" />
    <circle cx={12} cy={9} r={2.4} />
  </svg>
);

/** Доска в звонке — кнопка панели звонка (задача 2026-09-10). */
export const IconBoard = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x={3.2} y={3.4} width={17.6} height={12.2} rx={2} />
    <path d="M7 11.8c1.4-2.6 2.8-2.6 4.2 0s2.8 2.6 4.2 0" />
    <path d="M12 15.6v2.2M8.6 20.6 12 17.8l3.4 2.8" />
  </svg>
);

/** Ластик — панель рисования .draw-panel (задача 2026-09-10). */
export const IconEraser = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <g transform="rotate(-45 12 12)">
      <rect x={6} y={9} width={12} height={7} rx={1.5} />
      <path d="M6 13h12" />
    </g>
  </svg>
);

/** Отмена последнего штриха — панель рисования .draw-panel (задача 2026-09-10). */
export const IconUndo = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 10h10a5 5 0 0 1 0 10h-2" />
    <path d="M7 6 3 10l4 4" />
  </svg>
);

/** Копирование ссылки — плашка звонка в карточке события (задача 10.09.2026,
 * макет docs/ui-audit/2026-09-10-call-block.html, значок-призрак варианта А). */
export const IconCopy = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x={9} y={9} width={11} height={11} rx={2} />
    <path d="M5 15V5a2 2 0 0 1 2-2h10" />
  </svg>
);

/** Сохранить в файл — кнопка «Сохранить в файл» в шапке сцены звонка (раздел 5.1 спеки доски). */
export const IconSave = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M5.5 4.5h10l3 3v11a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5V6a1.5 1.5 0 0 1 1.5-1.5z" />
    <rect x={8} y={4.5} width={6} height={4.5} />
    <rect x={7} y={13.5} width={10} height={5.5} />
  </svg>
);

/** Договоры: лист с загнутым углом, строки и росчерк подписи — раздел «Договоры» (26.09.2026). */
export const IconContract = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M13.75 3.5H7a1.5 1.5 0 0 0-1.5 1.5v14a1.5 1.5 0 0 0 1.5 1.5h10a1.5 1.5 0 0 0 1.5-1.5V8.25z" />
    <path d="M13.75 3.5v4.75h4.75" />
    <path d="M8.75 11.5h6.5M8.75 14.5h4" />
    <path d="M8.75 17.5c.8-.9 1.5-.9 2 0s1.2.9 2 0" />
  </svg>
);

/** Мои задания: список с отметкой — раздел заданий (13.09.2026). */
export const IconTasks = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 6h11M9 12h11M9 18h11" />
    <path d="m3 5.6 1.4 1.4L7 4.4" strokeWidth={2} />
    <path d="M3.4 12h2.2M3.4 18h2.2" strokeWidth={2} />
  </svg>
);

/** Финансы: кошелёк — раздел реестров платёжных дней и заявок на оплату (07.10.2026). */
export const IconWallet = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 7.5A1.5 1.5 0 0 1 5.5 6H18a1 1 0 0 1 1 1v2" />
    <path d="M4 7.5v10A1.5 1.5 0 0 0 5.5 19H19a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H5.5A1.5 1.5 0 0 1 4 7.5Z" />
    <path d="M16 14h.01" strokeWidth={2.4} />
  </svg>
);

/** Почта: конверт — способ связи в карточке контакта (17.09.2026). */
export const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M3.5 6.5h17a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1Z" />
    <path d="m3 7.5 9 6 9-6" />
  </svg>
);

/** Дом: пункт «Главная» в меню и плитки разделов (17.09.2026). */
export const IconHome = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 10.5 12 4l8 6.5" />
    <path d="M6 9.5V20h12V9.5" />
    <path d="M10 20v-5.5h4V20" />
  </svg>
);

/** Замок: внутренняя ветка замечаний к договору — подрядчик её не видит (3.56). */
export const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="11" width="14" height="10" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);

/*
 * Кольцо цикла: дуга почти в полный круг со стрелкой у верхнего конца
 * (3.54 «Кольцо круга»). Отличается от `IconRepeat` работой: та показывает
 * повтор сама по себе, а этой внутрь садится номер круга, поэтому дуга
 * отодвинута к самому краю коробки, разрыв один, а наконечник собран
 * короткими бортами — место в середине рабочее.
 */
export const IconCycle = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M18.58 5.42A9.3 9.3 0 1 1 12 2.7" />
    {/* Борта наконечника разведены от самой дуги, а не от касательной к её
        концу: дуга под наконечником уже отвернула, и симметричные по
        касательной борта садились на кольцо криво — верхний уходил за дугу на
        2,10, нижний внутрь всего на 1,13, и наконечник заваливался наружу
        (замечание Ильи 22.09.2026). Длина бортов и раствор прежние, повёрнут
        только сам наконечник — на 9,27°, по хорде той дуги, которую он
        закрывает. Стало: 1,68 наружу и 1,67 внутрь. */}
    <path d="M8.77 1.51 12 2.7 9.31 4.86" />
  </svg>
);

/*
 * Знак процесса: этап, из которого ход расходится на параллельные, — схема
 * 3.54 в миниатюре. Стоит у вкладки, на которой живёт ход процесса (3.60), и
 * значит ровно одно: здесь видно, где запись стоит и что с ней делать.
 *
 * Почему ветвление, а не два этапа в строку. Прежде знак был двумя
 * одинаковыми прямоугольниками 6 × 8 на одной высоте с перемычкой между
 * ними, и складывался он в гантель (замечание Ильи 22.09.2026): у гантели
 * перекладина стоит ровно между двух равных грузов, и от процесса в рисунке
 * не оставалось ничего. Развилка гантелью не читается ни при каком
 * прищуре — у неё три конца, а не два, и связи в ней идут уступом, а не
 * прямой перекладиной. Два этапа подряд, чем их ни рисуй — кружками,
 * карточками, тремя штуками в ряд, — так и остаются гирями на грифе:
 * проверено живыми образцами в 18, 24 и 48 px.
 *
 * Параллель тут не выдумана: у договора визирование и есть три одновременные
 * визы, у первичной проверки — юридическая с финансовой, и именно так их
 * рисует сама схема 3.54. Знак повторяет её вход в параллельную пару.
 *
 * От соседей отличается связями. `IconMap` — три кружка на ломаной, без
 * развилки: там путь между точками. `IconOrg` — три прямоугольника
 * подчинением сверху вниз: там кто под кем, а не что за чем. Знак «поделиться»
 * ставит те же три кружка на прямые лучи из одной точки; здесь связи идут
 * стеблем и уступом — так рисуют схему, а не веер. Своей второй работы у
 * знака по-прежнему нет, поэтому `IconCycle` (номер круга внутри дуги) и
 * `IconTasks` (список заданий) его не заменяют: первый про повтор, второй
 * про перечень.
 */
export const IconProcess = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <circle cx={4} cy={12} r={2} />
    <circle cx={20} cy={6.5} r={2} />
    <circle cx={20} cy={17.5} r={2} />
    <path d="M6 12h4.6V6.5H18" />
    <path d="M10.6 12v5.5H18" />
  </svg>
);

/** Секущая плоскость на модели — полоса инструментов вкладки «Модель» (дизайн-система 3.66). */
export const IconSection = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3.5l7.5 4v9l-7.5 4-7.5-4v-9l7.5-4z" />
    <path d="M3 12h18" strokeDasharray="2 2.5" />
  </svg>
);
